"use client";

import Form from "@/screens/homepage/sections/form";
import Loader from "@/components/ui/Loader";
import { Suspense } from "react";

export default function InlineForm() {
  return (
    <div className="m-auto max-w-screen-sm px-10 py-16 lg:px-24 lg:py-24">
      <Suspense fallback={<Loader />}>
        <Form />
      </Suspense>
    </div>
  );
}
